import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ServiceProvidersService {

  public spSearchVar = new BehaviorSubject<boolean>(false);
  public serviceProvidersList = new BehaviorSubject<{}>({});
  public serviceProvider: Observable<any>;
  public searchItem = new BehaviorSubject<{}>({
    serviceProviderId: '',
    marketId: [],
    serviceId: [],
    industryId: [],
    focusAreaId: [],
    filterType: ['tech_analyst'],
    rating: null,
    orderBy: 'sequence, name asc',
    limit: 7,
    offset: 0,
    searchQuery: '',
    isCreateProject: false
  });
  searchFilters:any;
  public searchItemObservable: Observable<any>;

  constructor(private httpClient: HttpClient) {
    this.serviceProvider = this.serviceProvidersList.asObservable();
    this.searchItemObservable = this.searchItem.asObservable();
  }

  getSelectedFilters(){
    return this.searchFilters;
  }
  setSelectedFilters(filters){
    this.searchFilters = filters;
  }

  resetStoredValues(){
    this.searchFilters=null;
  }

  getSpSearchVar() {
    return this.spSearchVar.asObservable();
  }

  storSpSearchVar(isSp) {
    this.spSearchVar.next(isSp);
  }

  getServiceProvidersList(searchObj: any): Observable<any> {
    return this.httpClient.post(`/AnalystDetailViews/getSearchList`, searchObj);
  }

  getServiceProvider(userId): Observable<any> {
    return this.httpClient.get(`AnalystDetailViews/analyst-detail?userId=${userId}`);
  }
  
  getAnalystDetails(userId): Observable<any> {
    return this.httpClient.get(`AnalystDetailViews/analyst-detail/${userId}`);
  }

  updateServiceProviders(sp, searchItems, queryReturnData?) {
    if (!queryReturnData) {
      this.serviceProvidersList.next(sp);
    } else {
      this.serviceProvidersList.next({
        queryReturnData: [...queryReturnData , ...sp.queryReturnData],
        totalCount: sp.totalCount
      });
    }
    this.searchItem.next(searchItems);
  }

  getSpEndorsements(serviceProviderId): Observable<any> {
    return this.httpClient.get(`/Endorsements/service-endorse-list?serviceProviderId=${serviceProviderId}`);
  }

  getUserHighlights(userId, limit, skip): Observable<any> {
    return this.httpClient.get(`/profiles/user-highlights?userId=${userId}&limit=${limit}&skip=${skip}`);
  }

  getSpSocialFeeds(userId, limit, skip, search): Observable<any> {
    return this.httpClient.get(`/social-feeds/feed?limit=${limit}&skip=${skip}&serviceProviderId=${userId}&search=${search}`);
  }

  endorseSp(serviceProviderServiceId): Observable<any> {
    const endorseQuery = {
      serviceProviderServiceId
    };
    return this.httpClient.post('/Endorsements/endorseServiceProvider', endorseQuery);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/service-providers.service.ts